export const adap_comision_usuario = (comisiones, usuario, entidad ) => {

    let obj = {
        ...comisiones,
        idUsuario: usuario.id,
        nombre: usuario.nombre,
        correo: usuario.correo,
        fecha: new Date().getTime(),
        zona: entidad.zona,
        producto: entidad.nombre,
        valorProducto: entidad.valor,
        tipo: entidad.tipo,
        rango: usuario.rango,
        estado: entidad.estado ? entidad.estado : 'Simulacion',

    }

    return obj

}
